

















import { Component, Mixins } from "vue-property-decorator";
import { Size, Point } from "../../../../domain/drawing";
import { SvgPathFactory } from "../../../drawing/utilities";
import { DrawableObjectMixin } from "./mixins";

@Component({
})
export default class RangeOfMotionGraph extends Mixins(
  DrawableObjectMixin
) {
  get low(): number {
    return this.readPropertyOrDefault(s => s.rangeOfValue.low, null);
  }

  get high(): number {
    return this.readPropertyOrDefault(s => s.rangeOfValue.high, null);
  }

  get min(): number {
    return this.readPropertyOrDefault(s => s.limitOfValue.min, null);
  }

  get max(): number {
    return this.readPropertyOrDefault(s => s.limitOfValue.max, null);
  }

  get hasValue(): boolean {
    return this.isValid(this.low)
        && this.isValid(this.high);
  }

  private isValid(value: number): boolean {
    return (value != null)
        && !isNaN(value);
  }

  /**
   * 強直の表示するかどうか
   */
  get isFixed(): boolean {
    return this.hasValue
        && (this.high === this.low);
  }

  get path(): string {
    if (this.isFixed) { return null; }
    return SvgPathFactory.createHorizontalLine(
      new Point(this.calculateX(this.low), this.rectangle.size.height / 2),
      this.calculateX(this.high)
    );
  }

  get arrowSize(): Size {
    return new Size(5, 8);
  }

  get arrowToPath(): string {
    return SvgPathFactory.createPolyline(
      new Point(0, 0),
      new Point(this.arrowSize.width, this.arrowSize.height / 2),
      new Point(0, this.arrowSize.height)
    );
  }

  get arrowFromPath(): string {
    return SvgPathFactory.createPolyline(
      new Point(this.arrowSize.width, 0),
      new Point(0, this.arrowSize.height / 2),
      new Point(this.arrowSize.width, this.arrowSize.height)
    );
  }

  get lowIndicatePath(): string {
    return this.createIndicatePath(this.low);
  }

  get highIndicatePath(): string {
    return this.createIndicatePath(this.high);
  }

  private createIndicatePath(value: number): string {
    if (this.isFixed) { return null; }
    return SvgPathFactory.createVerticalLine(
      new Point(this.calculateX(value), 0),
      this.rectangle.size.height
    );
  }

  private calculateX(value: number): number {
    return (value - this.min) * this.rectangle.size.width / (this.max - this.min);
  }

  get fixMarkPath(): string {
    if (!this.isFixed) { return null; }
    const x = this.calculateX(this.low);
    const margin = Math.round(this.rectangle.size.height / 8);
    const r = Math.round(this.rectangle.size.height / 5);
    return SvgPathFactory.createWaveLine(new Point(x, margin), new Point(x, this.rectangle.height - margin), r);
  }

  get isVisible(): boolean {
    return this.editingSource.isVisible;
  }
}
